import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import WebAppConfigService from '../services/WebAppConfigService';

dayjs.extend(utc);
dayjs.extend(timezone);

const STORAGE_KEY = 'app_timezone';
const DEFAULT_TZ = 'Europe/Sofia';

export const getAppTimezone = () => {
    return localStorage.getItem(STORAGE_KEY) || DEFAULT_TZ;
};

export const setAppTimezone = tz => {
    if (tz) localStorage.setItem(STORAGE_KEY, tz);
};

export const loadAppTimezone = async () => {
    try {
        const res = await WebAppConfigService.getAll();
        const tz = res && res.data && res.data[0] && res.data[0].timezone;
        if (tz) setAppTimezone(tz);
        return tz || getAppTimezone();
    } catch (e) {
        console.warn('Failed to load app timezone, using cached/default', e);
        return getAppTimezone();
    }
};

// Format a server timestamp in the configured app timezone.
// Returns '' for null/empty inputs.
export const formatInTz = (value, fmt, locale) => {
    if (!value || value === 'null' || value === 'empty') return '';
    const d = dayjs(value).tz(getAppTimezone());
    return locale ? d.locale(locale).format(fmt) : d.format(fmt);
};

// Returns a JS Date whose local-time fields (getHours, getDate, getMonth, ...)
// match the wall-clock time in the configured app timezone, regardless of
// the browser's actual timezone. Use where downstream code reads native Date
// getters for custom formatting/exporting.
export const toTzDate = value => {
    if (!value) return null;
    const tzStr = getAppTimezone();
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tzStr,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).formatToParts(new Date(value));
    const map = {};
    for (const p of parts) map[p.type] = p.value;
    const hour = map.hour === '24' ? '00' : map.hour;
    return new Date(
        parseInt(map.year, 10),
        parseInt(map.month, 10) - 1,
        parseInt(map.day, 10),
        parseInt(hour, 10),
        parseInt(map.minute, 10),
        parseInt(map.second, 10)
    );
};
